export default __webpack_public_path__ + "static/media/Manuable_Ofrecemos.4a842d24.png";